import React from "react";
import Helmet from "react-helmet";
import Code from "../Code";

const helloWorldCode = `<!DOCTYPE html>

 <html lang="en">
   <head>
     <meta charset="UTF-8" />
     <meta name="viewport" content="width=device-width, initial-scale=1.0" />
     <title>Hello World With HTML</title>
   </head>
   <body>
     <p> Hello World! </p>
   </body>
 </html>`;

function HTMLIntroduction() {
  return (
    <div className="main-content">
      <Helmet>
        <title>HTML Introduction</title>
        <meta
          name="description"
          content="In this article, we will start learning about the Hypertext markup language."
        />
      </Helmet>
      <main>
        <h1>Hypertext Markup Language</h1>
        <p>
          The HyperText Markup Language, or HTML is the standard markup language
          for documents designed to be displayed in a web browser. Web browsers
          receive HTML documents from a web server and render the documents into
          multimedia web pages. The current specification is the HTML5.
        </p>
        <h2>Hello World!</h2>
        <Code code={helloWorldCode} language="html"></Code>
      </main>
    </div>
  );
}

export default HTMLIntroduction;
